<div class="fixed top-4 right-4 z-50 flex flex-col gap-2 pointer-events-none">
  <div
    *ngFor="let toast of toasts()"
    class="flex items-start gap-3 px-4 py-3 rounded-lg shadow-lg pointer-events-auto animate-slideIn"
    [ngClass]="{
      'bg-green-50 border border-green-200': toast.type === 'success',
      'bg-red-50 border border-red-200': toast.type === 'error',
      'bg-yellow-50 border border-yellow-200': toast.type === 'warning',
      'bg-blue-50 border border-blue-200': toast.type === 'info'
    }"
  >
    <span
      class="flex-shrink-0 text-lg font-semibold"
      [ngClass]="{
        'text-green-600': toast.type === 'success',
        'text-red-600': toast.type === 'error',
        'text-yellow-600': toast.type === 'warning',
        'text-blue-600': toast.type === 'info'
      }"
    >
      {{ getIcon(toast.type) }}
    </span>
    <p
      class="flex-1 text-sm font-medium whitespace-normal break-words max-w-sm"
      [ngClass]="{
        'text-green-800': toast.type === 'success',
        'text-red-800': toast.type === 'error',
        'text-yellow-800': toast.type === 'warning',
        'text-blue-800': toast.type === 'info'
      }"
    >
      {{ toast.message || 'Notification' }}
    </p>
    <button
      (click)="removeToast(toast.id!)"
      class="flex-shrink-0 text-gray-400 hover:text-gray-600 transition"
    >
      ✕
    </button>
  </div>
</div>
